import React, { useState, useEffect } from 'react'
import AnimationLayout from '../components/AnimationLayout'
import Select from 'react-select'
import Button from '../components/Button'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import moment from 'moment'
import 'moment/locale/pt'
moment.locale('pt')

const TravelAlbum = () => {
    const [state, setState] = useState({
        filterType: '',
        filterMethod: '',
        showAllPhotos: false,
        photos: []
    })

    const toggle = (photo) => {
        photo ? setState({ ...state, open: !state.open, selectedPhoto: photo }) : setState({ ...state, open: !state.open })
    }

    const user = useSelector(state => state.apiCalls.apiData.user)
    const loggedUser = useSelector(state => state.firebase.profile)
    const isLoggedInUserProfile = user?.username ? false : true
    const userObject = user?.username ? user : loggedUser
    const { travelBook } = userObject
    const { showAllPhotos, photos } = state

    const photosPortion = photos.slice(0, 9)
    const remainingPhotos = photos.slice(9, photos.length)

    useEffect(() => {
        setState({ ...state, photos: travelBook })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const updateInput = (ev, { action }) => {
        if (action === 'clear') {
            setState({ ...state, filterType: null, photos: travelBook })
        } else {
            const { value } = ev
            setState({ ...state, filterType: value })
        }
    }

    const updateFilterMethod = (ev, { action }) => {
        if (action === 'clear') {
            setState({ ...state, filterMethod: null, photos: travelBook })
        } else {
            const { value, label } = ev
            const { filterType, photos } = state
            let returnPhotos

            if (value === 'ascendent') {
                if (filterType === 'caption') {
                    returnPhotos = photos.sort((a, b) => a.caption > b.caption)
                } else {
                    returnPhotos = photos.sort((a, b) => a.tookAt - b.tookAt)
                }
            } else if (value === 'descendent') {
                if (filterType === 'caption') {
                    returnPhotos = photos.sort((a, b) => a.caption < b.caption)
                } else {
                    returnPhotos = photos.sort((a, b) => b.tookAt - a.tookAt)
                }
            } else if (filterType === 'travel') {
                returnPhotos = photos.filter(item => item.country.includes(value))
            }

            setState({ ...state, photos: returnPhotos, filterMethod: { value, label }, showAllPhotos: false })
        }
    }

    const typeOptions = [
        { value: 'travel', label: 'País' },
        { value: 'data', label: 'Data' },
        { value: 'caption', label: 'Nome' }
    ]

    const methodOptions = state.filterType !== 'travel' ?
        [
            { value: 'ascendent', label: 'Ascendente' },
            { value: 'descendent', label: 'Descendente' }
        ]
        :
        [
            { value: 'Brasil', label: 'Brasil' },
            { value: 'China', label: 'China' },
            { value: 'Grécia', label: 'Grécia' },
            { value: 'Sri Lanka', label: 'Sri Lanka' }
        ]

    const printPhotoEl = (item, index) => {
        let chapterNumber = item.chapter.split('-')

        return (
            <div key={index} className='item' onClick={() => toggle(item)}>
                <div className='polaroid text-center'>
                    <img
                        title={item.caption}
                        alt={item.caption}
                        className='object-contain rounded-sm'
                        src={require(`../assets/img/narrative/${item.photo}`)}
                    />
                    <h5 className='p-4 pb-2'>{item.caption}</h5>
                    <p className='pb-2'>Tirada no capítulo {chapterNumber[1]} - {item.country}</p>
                    <p>Fotografada {moment(item.tookAt.toDate()).fromNow()}</p>
                </div>
            </div>
        )
    }

    return (
        <AnimationLayout>
            <div id='travel-album'>
                <h1>Caderneta de viagens</h1>
                <div className='white-container py-4'>
                    <p className='pb-2'>Filtre ordem das fotos por:</p>
                    <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-0 lg:gap-8'>
                        <Select
                            options={typeOptions}
                            isClearable={true}
                            isSearchable={false}
                            placeholder='Selecione a forma de filtrar'
                            className='block appearance-none shadow appearance-none rounded w-full my-3'
                            onChange={updateInput}
                            classNamePrefix='react-select'
                            aria-label='Menu de formas de filtragem'
                            aria-labelledby='Formas de filtragem'
                        />

                        <Select
                            isDisabled={!state.filterType ? true : false}
                            options={methodOptions}
                            isClearable={true}
                            isSearchable={false}
                            placeholder='Selecione o método de filtragem'
                            className='block appearance-none shadow appearance-none rounded w-full my-3'
                            onChange={updateFilterMethod}
                            classNamePrefix='react-select'
                            aria-label='Menu de métodos de filtragem'
                            aria-labelledby='Método de filtragem'
                        />
                    </div>
                </div>
                {userObject.travelBook.length !== 0 ?
                    <>
                        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 justify-center mb-8'>
                            {userObject.travelBook.length && photosPortion.length === 0 ?
                                isLoggedInUserProfile ?
                                    <p>Não tem qualquer tipo de fotos do país - {state.filterMethod.label}</p>
                                    :
                                    <p>Este utilizador não tem qualquer tipo de fotos do país - {state.filterMethod.label}</p>
                                :
                                photosPortion.map((item, index) => printPhotoEl(item, index))
                            }
                            {showAllPhotos &&
                                remainingPhotos.map((item, index) => printPhotoEl(item, index))
                            }
                        </div>
                        {(photosPortion.length > 0 && !showAllPhotos) &&
                            <div className='flex justify-end mb-8'>
                                <Button className='mr-0' onClick={() => setState({ ...state, showAllPhotos: true })}>
                                    Ver todas as fotos
                                </Button>
                            </div>
                        }
                    </>
                    :
                    <div className='flex justify-center'>
                        {isLoggedInUserProfile ?
                            <div>
                                <p className='w-full'>Ainda não tirou qualquer tipo de foto! Comece já a viajar para começar a completar a caderneta!</p>
                                <Link to='/viajar'>
                                    <Button className='mr-0'>
                                        Ir para viajar
                            </Button>
                                </Link>
                            </div> :
                            <h5>Este utilizador não tem qualquer tipo de fotos na sua caderneta de viagens</h5>}
                    </div>
                }
            </div>
        </AnimationLayout>
    )
}

export default TravelAlbum